import { cn } from '../../lib/utils';
import { spinnerIcon } from '../../icons';

interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'default' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  default: 'h-5 w-5',
  lg: 'h-10 w-10',
};

function Spinner({ className, size = 'default' }: SpinnerProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block animate-spin', sizeClasses[size], className)}
      style={{
        backgroundColor: 'currentColor',
        maskImage: `url("${spinnerIcon}")`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: `url("${spinnerIcon}")`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
    />
  );
}

export { Spinner, type SpinnerProps };
